export default __webpack_public_path__ + "static/media/homePic.2d82dc64.png";